export default {
    values: {
        '%{dashboards} Dashboards': '%{dashboards} Dashboards',
        'feature_type_card_title.DASHBOARD': 'Dashboards',
        'feature_type_card_title.RULE': 'Rules',
        'feature_type_card_title.DATASOURCE': 'Datasources',
        'feature_type_card_title.PIPES_MODULE': 'Pipes modules',
        'feature_type_card_title.JS_SNIPPET': 'JS Snippets',
        'feature_type_card_title.CSS_SNIPPET': 'CSS Snippets',
        'feature_type_card_title.GROOVY_SNIPPET': 'Groovy Snippets',
        'feature_type_card_title.LOOKUP_TABLE': 'Lookup Tables',
        'feature_type_card_title.DASHBOARD_TEMPLATE': 'Dashboard Templates',
        'feature_type.DASHBOARD': 'Dashboard',
        'feature_type.RULE': 'Rule',
        'feature_type.DATASOURCE': 'Datasource',
        'feature_type.PIPES_MODULE': 'Pipes module',
        'feature_type.JS_SNIPPET': 'JS Snippet',
        'feature_type.CSS_SNIPPET': 'CSS Snippet',
        'feature_type.GROOVY_SNIPPET': 'Groovy Snippet',
        'feature_type.LOOKUP_TABLE': 'Lookup Table',
        'feature_type.DASHBOARD_TEMPLATE': 'Dashboard Template',
        'feature_type.PIPES_2_STATE': 'Pipes 2 State',
        'feature_type_card_title.PIPES_2_STATE': 'Pipes 2 State',
        'feature_type_card_title.LOOKUP_PIPES': 'Lookup Pipes',
        'This dashboard may still be visible to superusers and to who disabled it': 'This dashboard may still be visible to superusers and to who disabled it',
        missing_plugin_id_msg: ({ plugin }) =>
            `The package settings were removed, but its plugin (${plugin}) was not deleted because it was not found; if it does still exist, the package might be automatically registered again when Live restarts or other plugins are modified`
    }
}
